import { render, staticRenderFns } from "./SafetyObservationItemViewForm.vue?vue&type=template&id=65252138"
import script from "./SafetyObservationItemViewForm.vue?vue&type=script&lang=js"
export * from "./SafetyObservationItemViewForm.vue?vue&type=script&lang=js"
import style0 from "./SafetyObservationItemViewForm.vue?vue&type=style&index=0&id=65252138&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports